const state = () => ({
    tagsId: null , // 标签管理进入标签管理内容页面传递的标签id
    tagsObejct:{},
})

const getters = {
    getTagsId: (state) => state.tagsId
}

const mutations = {
    SET_TAGSID(state, payload) {
        state.tagsId = payload.id
        state.tagsObejct = payload
    },
}

const actions = {
    setTagsId({ commit }, array) {  // 修正参数名
        commit('SET_TAGSID', array)
    }
}

export default {
    namespaced: true,
    state,
    getters,  // 添加 getters
    actions,
    mutations,
}